import styled from "@emotion/styled";

import ArrowUpIcon from "./ArrowUpIcon";
import { TypographyT18 } from "Components/Common/Typography/index";
import { Spacer } from "Components/Common/Spacer/index";
import React, { Fragment } from "react";
const RateVariation = (props) => {
  const { rate, isActive } = props;
  return (
    <Fragment>
      <RateVariationWrapper>
        <TypographyT18 color={!!isActive?"#FFFFFF":""}>{rate}</TypographyT18>
        <Spacer spacing={"6px"} />
        <div style={{ paddingTop: "2px" }}>
          <ArrowUpIcon />
        </div>
      </RateVariationWrapper>
    </Fragment>
  );
};

export default RateVariation;

const RateVariationWrapper = styled("div")`
  display: flex;
  align-items: center;
`;
